import { ActionType } from "../constants/auth";
import {
  authApi,
  logoutApi,
  registerApi,
  fogotPasswordApi,
  resetPasswordApi,
  meApi
} from "../../api/auth/auth";

export const authAction = (data, onCLose) => dispatch => {
  return authApi(data)
    .then(
      dispatch({
        type: ActionType.AUTH_START
      })
    )
    .then(response => {
      localStorage.setItem("access_token", response.data.access_token);
      onCLose();
      dispatch({
        type: ActionType.AUTH_SUCESS,
        payload: response.data
      });
    })
    .catch(errors => {
      dispatch({
        type: ActionType.AUTH_ERRORS,
        payload:
          errors.response && errors.response.data ? errors.response.data : {}
      });
    });
};

export const authHandlingErrors = data => dispatch => {
  return dispatch({
    type: ActionType.AUTH_HANDLE_ERRORS,
    payload: data
  });
};

export const logoutAction = () => dispatch => {
  return logoutApi().then(response => {
    localStorage.removeItem("access_token");
    dispatch({
      type: ActionType.AUTH_LOGOUT
    });
  });
};

export const registerAction = (data, onClose, redirectHandler) => dispatch => {
  return registerApi(data)
    .then(
      dispatch({
        type: ActionType.REGISTER_START
      })
    )
    .then(response => {
      onClose();
      redirectHandler();
      dispatch({
        type: ActionType.REGISTER_SUCCESS,
        payload: response.data
      });
    })
    .catch(errors => {
      dispatch({
        type: ActionType.REGISTER_ERRORS,
        payload:
          errors.response && errors.response.data && errors.response.data.errors
            ? errors.response.data.errors
            : {}
      });
    });
};

export const fogotPasswordAction = (data, redirectHandler) => dispatch => {
  return fogotPasswordApi(data)
    .then(
      dispatch({
        type: ActionType.FOGOT_PASSWORD_START
      })
    )
    .then(response => {
      redirectHandler();
      dispatch({
        type: ActionType.FOGOT_PASSWORD_SUCCESS,
        payload: response.data
      });
    })
    .catch(errors => {
      dispatch({
        type: ActionType.FOGOT_PASSWORD_ERRORS,
        payload:
          errors.response && errors.response.data && errors.response.data.errors
            ? errors.response.data.errors
            : {}
      });
    });
};

export const resetPasswordAction = (data, redirectHandler) => dispatch => {
  return resetPasswordApi(data)
    .then(
      dispatch({
        type: ActionType.RESET_PASSWORD_START
      })
    )
    .then(response => {
      redirectHandler();

      dispatch({
        type: ActionType.RESET_PASSWORD_SUCCESS,
        payload: response.data
      });
    })
    .catch(errors => {
      dispatch({
        type: ActionType.RESET_PASSWORD_ERRORS,
        payload:
          errors.response && errors.response.data ? errors.response.data : {}
      });
    });
};

export const cleareAuthDataAction = () => dispatch => {
  return dispatch({
    type: ActionType.CLEAN_AUTH_DATA
  });
};

export const meAction = () => dispatch => {
  return meApi().then(response => {
    dispatch({
      type:  ActionType.GET_ME_DATA,
      payload: response.data
    })
  });
};


export const hideHelperAction = (data) => dispatch => {
    dispatch({
      type:  ActionType.GET_HELPER_DATA,
      payload: data
    })
};
